export default __webpack_public_path__ + "static/media/actionfigure-insight.16dc3215.svg";